const state = {
    themes: [
        {
            id: 1,
            primary: '#dde4e8',
            secondary: '#e26f3a'
        },
        {
            id: 2,
            primary: '#0f567e',
            secondary: '#e23a52'
        },
        {
            id: 3,
            primary: '#dce7e1',
            secondary: '#3ab8e2'
        },
        {
            id: 4,
            primary: '#d0e5f1',
            secondary: '#289a30'
        },
        {
            id: 5,
            primary: '#c22a1e',
            secondary: '#1f1f1f'
        }
    ],
    currentTheme: 1
}

const getters = {
    fetchThemes(state) {
        return state.themes;
    },
    fetchCurrentTheme(state) {
        return state.currentTheme;
    }
}
getters['fetchThemeById'] = (state) => (id) => {
    if (state.themes) {
        return state.themes.find(theme => theme.id === id)
    }
    return {}    
}

const actions = {
    setTheme(context, payload) {
        context.commit('SET_THEME', payload);
    }
}

const mutations = {
    SET_THEME(state, theme) {
        state.currentTheme = theme;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}